









import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-pause',

})
export default class IPause extends Vue {

}

